import React from "react";
import styles from "./ganttChart.module.scss";

const GanttChart = () => {
  return <div className={styles.container}> GanttChart</div>;
};

export default GanttChart;
